import { ComponentPropsWithoutRef } from "react";
import { Heading } from "~/components/elements/Heading";
import Grid from "~/components/globals/Grid";
import { SectionGridTwoColumns as ISectionGridTwoColumns } from "~/sanity/types";
import * as styles from "./SectionGridTwoColumns.css";
import { CardArchive } from "~/components/components/cards/CardArchive";
import { IImage, Image } from "~/components/elements/Image";

export type SectionGridTwoColumnsProps = ComponentPropsWithoutRef<"div"> & {
  data: ISectionGridTwoColumns;
};

export const SectionGridTwoColumns = ({
  data,
  ...props
}: SectionGridTwoColumnsProps) => {
  const { title, cards } = data;
  return (
    <section {...props}>
      <Grid>
        <div className={styles.content}>
          {title && (
            <Heading as="h2" size="h2">
              {title}
            </Heading>
          )}
          {cards && (
            <div className={styles.grid}>
              {cards.length % 2 !== 0 ? (
                <>
                  <div className={styles.oddCard({ isMobile: false })}>
                    <div className={styles.cardWrapper}>
                      <CardArchive
                        card={{ ...cards[0], image: undefined }}
                        className={styles.card}
                      />
                    </div>
                    <div className={styles.imageWrapper}>
                      {cards[0].image && (
                        <Image
                          image={cards[0].image as IImage}
                          className={styles.heroImage}
                          width={650}
                        />
                      )}
                    </div>
                  </div>
                  <div className={styles.oddCard({ isMobile: true })}>
                    <CardArchive card={cards[0]} />
                  </div>
                  {cards.slice(1).map((card, index) => (
                    <CardArchive card={card} key={index} />
                  ))}
                </>
              ) : (
                cards.map((card, index) => (
                  <CardArchive card={card} key={index} />
                ))
              )}
            </div>
          )}
        </div>
      </Grid>
    </section>
  );
};
